import kingWhite from './king-white.png'
import kingWhiteRotated from './king-white-rotated.png'
import kingBlack from './king-black.png'
import kingBlackRotated from './king-black-rotated.png'
import queenWhite from './queen-white.png'
import queenWhiteRotated from './queen-white-rotated.png'
import queenBlack from './queen-black.png'
import queenBlackRotated from './queen-black-rotated.png'
import rookWhite from './rook-white.png'
import rookWhiteRotated from './rook-white-rotated.png'
import rookBlack from './rook-black.png'
import rookBlackRotated from './rook-black-rotated.png'
import knightWhite from './knight-white.png'
import knightWhiteRotated from './knight-white-rotated.png'
import knightBlack from './knight-black.png'
import knightBlackRotated from './knight-black-rotated.png'
import bishopWhite from './bishop-white.png'
import bishopWhiteRotated from './bishop-white-rotated.png'
import bishopBlack from './bishop-black.png'
import bishopBlackRotated from './bishop-black-rotated.png'
import pawnWhite from './pawn-white.png'
import pawnWhiteRotated from './pawn-white-rotated.png'
import pawnBlack from './pawn-black.png'
import pawnBlackRotated from './pawn-black-rotated.png'

const images = {
  kingWhite,
  kingWhiteRotated,
  kingBlack,
  kingBlackRotated,
  queenWhite,
  queenWhiteRotated,
  queenBlack,
  queenBlackRotated,
  rookWhite,
  rookWhiteRotated,
  rookBlack,
  rookBlackRotated,
  knightWhite,
  knightWhiteRotated,
  knightBlack,
  knightBlackRotated,
  bishopWhite,
  bishopWhiteRotated,
  bishopBlack,
  bishopBlackRotated,
  pawnWhite,
  pawnWhiteRotated,
  pawnBlack,
  pawnBlackRotated,
}

export default images